import { reduxWrapper } from '@common/redux/store';
import React from 'react';
import { Streams } from "@kursk/components/pages/Streams/Streams";
import { loadEntitiesFromQuery } from "@kursk/utils/loadEntitiesFromQuery";
import { loadStreamsBannersThunk } from "@common/redux/slices/streamsBanners.slice";

export default function StreamsPage() {
  return <Streams/>;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, query }) => {
  await Promise.all([
    loadEntitiesFromQuery('streams', query, store),
    store.dispatch(loadStreamsBannersThunk({})),
  ]);

  return { props: {} };
})
